import * as React from 'react';
import type { SVGProps } from 'react';
const SvgShebaIr = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={16} height={11} fill='none' {...props}>
    <g clipPath='url(#shebaIR_svg__a)'>
      <path
        fill='#26C6DA'
        d='M.473.979h3.103V11H.473zM5.846 11V.979h5.16q1.437 0 2.195.246.759.246 1.224.916.465.663.465 1.62 0 .834-.356 1.442a2.8 2.8 0 0 1-.977.978q-.397.24-1.087.396.554.184.806.37.17.122.493.526.327.403.437.622L15.703 11h-3.5L10.55 7.938q-.315-.595-.56-.773a1.3 1.3 0 0 0-.76-.232h-.273V11zm3.11-5.96h1.306q.211 0 .82-.138a.8.8 0 0 0 .5-.314.9.9 0 0 0 .197-.581q0-.486-.307-.745-.307-.26-1.156-.26h-1.36z'
      />
    </g>
    <defs>
      <clipPath id='shebaIR_svg__a'>
        <path fill='#fff' d='M0 0h16v11H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgShebaIr;
